import { createColumnHelper } from "@tanstack/react-table";
import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
const columnHelper = createColumnHelper();

export const bulkSparesTableColumnsConfig = (
  handleDownload,
  handleNavigate,
) => [
  columnHelper.accessor("request_id", {
    header: "Request Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("lot_name", {
    header: "Lot Name",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("lot_price", {
    header: "Lot Price",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("inspection_available", {
    header: "Inspection",
    cell: ({ getValue }) => {
      const value = getValue();
      const isAvailable = value === "yes";
      const label = isAvailable ? "Available" : "Not Available";

      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px 12px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: isAvailable ? "#E6F9F0" : "#FDECEC",
            color: isAvailable ? "#16A34A" : "#FE0000",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </div>
      );
    },
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("approval_status", {
    header: "Approval Status",
    cell: ({ getValue, row }) => {
      const status = getValue();

      const statusConfig = {
        approved: {
          label: "Approved",
          bg: "#E6F7EF",
          color: "#00A167",
          Icon: CheckCircleIcon,
        },
        pending: {
          label: "Pending",
          bg: "#FFF4E5",
          color: "#FF8C00",
          Icon: ClockIcon,
        },
        rejected: {
          label: "Rejected",
          bg: "#FDECEC",
          color: "#E53935",
          Icon: XCircleIcon,
        },
      };

      const config = statusConfig[status];

      if (!config) return "-";

      const { label, bg, color, Icon } = config;

      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: bg,
            color,
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          // onClick={() => handleOpenModal(row.original)}
        >
          <Icon style={{ width: 14, height: 14 }} />
          {label}
        </div>
      );
    },
    footer: (props) => props.column.id,
  }),

  columnHelper.display({
    id: "download",
    header: <div style={{ textAlign: "center" }}>Download</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          onClick={() => handleDownload(props.row.original.request_id)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",

            padding: "6px 12px",

            background: "rgba(58, 63, 143, 0.08)",
            color: "#3A3F8F",

            border: "1px solid rgba(58, 63, 143, 0.25)",
            borderRadius: "6px",

            fontSize: "13px",
            fontWeight: 500,

            cursor: "pointer",

            transition: "all 0.18s ease",

            backdropFilter: "blur(4px)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(58, 63, 143, 0.16)";
            e.currentTarget.style.border = "1px solid rgba(58, 63, 143, 0.4)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(58, 63, 143, 0.08)";
            e.currentTarget.style.border = "1px solid rgba(58, 63, 143, 0.25)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <ArrowDownTrayIcon
            style={{
              width: 15,
              height: 15,
            }}
          />
          Download
        </button>
      </div>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          disabled={props.row.original.approval_status === "pending for status"}
          onClick={() => handleNavigate(props.row.original.request_id)}
          style={{
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
          }}
        >
          View Inventory
        </button>
      </div>
    ),
  }),
];
